import { useContext } from 'react';
import { UserContext } from 'context/User/UserContext';
import PageWithBreadcrumbs from '../layouts/PageWithBreadcrumbs';
import NewJobCategoryMappingForm from './NewFormView';

/**
 * Epic Job Category Mapping Form for creating new or editing existing job category mapping
 * @param {any} props properties from router
 * @returns Job Category Mapping Editor page view
 */
const NewView = props => {
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const maintenanceUser = contextUser?.userInfo?.impersonationProfile
		? { ...contextUser?.userInfo?.impersonationProfile }
		: { ...contextUser.userInfo.userProfile };

	return (
		<PageWithBreadcrumbs currentPageLabel={'New Job Category Mapping'}>
			<NewJobCategoryMappingForm
				maintenanceInformation={maintenanceUser}
			/>
		</PageWithBreadcrumbs>
	);
};

export default NewView;
